module.exports = __webpack_public_path__ + "static/media/sq-choose-theme-poster.8fecff6e.png";